module.exports = __webpack_public_path__ + "media/components/Application/FormTags/Categories/30-7f05c654382b4dd7d46aeaa0107362a6.png";